import { isAffirmative } from "@/utils/isAffirmative/isAffirmative";

// [label, number], e.g. ["UK", "0800 316 9337"]. Not a tuple type: the
// pinned @typescript-eslint/parser@2 can't parse TS 5 tuples.
export type EapPhoneEntry = string[];

export type EapContentResponse = {
  success?: boolean;
  eap_customisation?: {
    custom_eap?: unknown;
    defaults?: { eap_phone?: unknown };
  } | null;
};

// Turning Custom EAP off in CORE keeps the saved numbers in the response, so the
// flag decides whether they apply. Empty means the booking journey shows its default line.
export const extractEapPhoneNumbers = (
  response: EapContentResponse | null | undefined,
): EapPhoneEntry[] => {
  const customisation = response?.success ? response.eap_customisation : null;
  if (!customisation || !isAffirmative(customisation.custom_eap)) return [];

  const phones = customisation.defaults?.eap_phone;
  if (!Array.isArray(phones)) return [];

  return phones.map(([label, encodedNumber]) => [
    label,
    decodeURIComponent(encodedNumber),
  ]);
};
